export const HOTELS_HAPI = __WHITE_LABEL__ ? '/_hotels/api' : '/_hotels/solartrip/api';

export const statuses = {
  classic: 'classic',
  premium: 'premium',
  pro: 'pro',
  exclusive: 'exclusive',
  guest: 'guest',
} as const;
